import { atomWithHash } from '@/atoms/atomWithHash';

export const teamMemberLoginMethodAtom = atomWithHash<
  | 'LoggedWithSameAccount'
  | 'LoggedWithDifferentAccount'
  | 'SignIn'
  | 'SignUp'
  | 'Welcome'
  | 'InvalidLink'
  | undefined
>('teamMemberLoginMethod', 'Welcome', {
  setHash: 'replaceState',
});

export const userSignedUpViaInvite = atomWithHash<boolean>(
  'userSignedUpViaInvite',
  false,
  {
    setHash: 'replaceState',
  }
);
